import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  helpContainer: {
    alignItems: 'center',
    columnGap: '5px',
    display: 'flex',
  },
  card: {
    borderBottomStyle: 'solid',
    borderBottomWidth: '0px',
    borderLeftStyle: 'solid',
    borderLeftWidth: '5px',
    borderRightStyle: 'solid',
    borderRightWidth: '0px',
    borderTopStyle: 'solid',
    borderTopWidth: '0px',
  },
  label: {
    alignItems: 'center',
    columnGap: '5px',
    display: 'flex',
  },
});
